class ENodes {
  #eNodes = new Map();

  set(key, value) {
    this.#eNodes.set(key, value);
  }

  get(key) {
    return this.#eNodes.get(key);
  }

  delete(key) {
    this.#eNodes.delete(key);
  }
}

const eNodes = new ENodes();
export { ENodes, eNodes };
